import { Toolbar, Typography, Button } from '@mui/material';
import {
	AppBarStyled,
	DrawerToggle,
	DrawerToggleButton,
} from 'shared/_components/app-layout/app-bar/styles';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Menu from '@mui/icons-material/Menu';
import { Header } from 'shared/Pages/common/Header';
import { useAtom } from 'jotai';
import { drawerExpandedAtom, drawerOpenAtom } from 'shared/_components/app-layout/store';

export default function AppBar() {
	const [drawerOpen, setDrawerOpen] = useAtom(drawerOpenAtom);
	const [drawerExpanded, setDrawerExpanded] = useAtom(drawerExpandedAtom);

	return (
		<>
			{/* Outside the AppBar so its z-index is not capped by the AppBar's stacking context (must sit above the drawer) */}
			<DrawerToggle expanded={drawerExpanded}>
				<DrawerToggleButton
					onClick={() => {
						setDrawerExpanded((s) => !s);
					}}
					size="small"
					aria-label="menu"
				>
					{drawerExpanded ? <ChevronLeft /> : <ChevronRight />}
				</DrawerToggleButton>
			</DrawerToggle>
			<AppBarStyled open={drawerOpen} expanded={drawerExpanded} color="inherit">
				<Toolbar sx={(theme) => ({
					px: theme.spacing(4),
					[theme.breakpoints.up('sm')]: {
						pl: theme.spacing(6), // leave room for the toggle button on the sidebar edge
						pr: theme.spacing(4),
					},
				})}>
					<Button
						startIcon={<Menu
							// fontSize="1.25rem"
							width={20} height={20}
						/>}
						// size="large"
						onClick={() => {
							setDrawerOpen((s) => !s);
						}}
						// edge="start"
						// color="inherit"
						aria-label="menu"
						sx={(theme) => ({
							p: 2, // theme.spacing(2),
							mr: 2,
							display: { sm: 'none' },
							'.MuiButton-startIcon': {
								mx: 0,
							},
							// '&.MuiButton-root .MuiButton-startIcon > svg': {
							// 	fontSize: theme.spacing(6),
							// // width: '20px', height: '20px',
							// }
						})}
					/>
						{/*<Menu width={20} height={20} />*/}
					{/*</Button>*/}
					{/*<IconButton*/}
					{/*	onClick={() => {*/}
					{/*		setDrawerOpen((s) => !s);*/}
					{/*	}}*/}
					{/*	edge="start"*/}
					{/*	color="inherit"*/}
					{/*	aria-label="menu"*/}
					{/*	sx={{ mr: 2, display: { sm: 'none' } }}*/}
					{/*>*/}
					{/*	<Menu />*/}
					{/*</IconButton>*/}
					{/* No `noWrap`: it sets overflow:hidden, which clips the quick search results dropdown */}
					<Typography variant="h6" component="div" sx={{ flexGrow: 1, minWidth: 0 }}>
						<Header />
					</Typography>
				</Toolbar>
			</AppBarStyled>
		</>
	);
}
